import { toJS } from 'mobx';
import { ViewModel } from '../interfaces/ViewModel';

/**
 * 此处实现默认解包的行为
 * @param vm
 * @param key
 * @param auto_unbox
 */
export function unbox(vm: ViewModel, key: string, auto_unbox: boolean | string[]) {
  if (auto_unbox === false) return vm[key];

  const shouldUnBox = (key: string) => {
    if (auto_unbox === true) return true;
    if (String(key).toUpperCase().includes('STYLE')) return true;
    return Array.isArray(auto_unbox) && auto_unbox.includes(key);
  };

  return shouldUnBox(key) ? toJS(vm[key]) : vm[key];
}
